export class BlockTime {
    constructor(jsonStructure) {
        this.bar = jsonStructure.bar;
        this.beat = jsonStructure.beat;
        this.subdivision = jsonStructure.subdivision;
    }
}

export class BlockPosition {
    constructor(jsonStructure) {
        // Add backwards compatibility for both start/end and start_time/end_time formats
        const startTime = jsonStructure.start_time || jsonStructure.start;
        const endTime = jsonStructure.end_time || jsonStructure.end;
        
        if (!startTime || !endTime) {
            console.error('BlockPosition missing required time fields:', jsonStructure);
        }
        
        this.start_time = new BlockTime(startTime);
        this.end_time = new BlockTime(endTime);
    }
}
